import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button, Row, Col } from 'reactstrap'
import LoadingOverlay from "react-loading-overlay"
import { useTranslation } from 'react-i18next'

import useFetchStatus from 'customHooks/useFetchStatus'
import Form from 'main_views/components/Form/form_v2'
import { updateForm, setFieldValue, getFieldsValues } from 'main_views/form/formHandler'
import { successToast, errorToast, warningToast } from 'main_views/components/toast'
import { addDoc, updateDoc } from 'dbHandler'
import formFields from './fields'
import Modal from "main_views/components/Modal"
import i18n from 'utils/translation/i18n'

/**
 * show the staff modal (to add | edit staff)
 *
 */
function StaffModal(props) {

   let { t } = useTranslation()

   let { staffList, staffIsLoading, updateFormList, isOpen, toggle, selectedStaff, isEdit = false } = props

   let [form, setForm] = useState()
   let [staffOptsList, setStaffOptsList] = useState()
   let [loading, setloading] = useState(false)

   // set staff options for the droplists
   useEffect(() => {
      if (props.staffIsLoading) return

      let staffOptsList = staffOpts(staffList)
      
      setStaffOptsList(staffOptsList)

   }, [props.staffIsLoading, staffList])

   // set form fields
   useEffect(() => {

      if(!isOpen) return 

      let result

      if (isEdit) {
         
         result = getEditForm(selectedStaff, staffOptsList)
   
      } else {

         // new form
         result = _.cloneDeep(formFields)
         result.manager.options = staffOptsList
         result.supervisor.options = staffOptsList

      }

      setForm(result)

   }, [isOpen])
   

   let setChanges = (stateName, value, className) => {
      setFieldValue(form, stateName, value, className)
      setForm({ ...form }) // to re-render the form 
   }

   let validation = async () => {

      let { isValid, data } = getFieldsValues(form)
      console.log("validation -> { isValid, data }", { form, isValid, data })

      if (!isValid) return errorToast('Please complete the form')

      // handel the data
      _.set(data, 'department', _.get(data, 'department.value', ''))
      _.set(data, 'role', _.get(data, 'role.value', ''))
      _.set(data, 'manager', _.get(data, 'manager.value', ''))
      _.set(data, 'supervisor', _.map(data.supervisor, 'value', []))

      let staffPermissons = {}
      _.forEach(data.permissons, permisson => {
         staffPermissons[permisson.id] = permisson.checked
      })

      _.set(data, 'permissons', staffPermissons)

      // prevent assign the same staff as manager & supervisor at the same time
      if (data.supervisor.includes(data.manager)) return errorToast(`Can't set the staff manager as a supervisor too`)

      console.log("validation -> { isValid, data }", { form, isValid, data })

      isEdit ? updateStaffInfo(data) : addNewStaff(data)

   }

   let addNewStaff = async (data) => {

      console.log({ data })

      delete data.confirmPassword
      
      let url = `https://us-central1-tickting-system.cloudfunctions.net/createStaff`
      let options = {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json'
         },
         body: JSON.stringify(data),
         redirect: 'follow'
      }

      setloading(true)

      try {

         let response = await fetch(`${url}`, options)

         if (!response.ok)
            throw await Promise.reject(await response.json())

         updateFormList()
         successToast(t('staff_was_added'))
         toggle()

      } catch (error) {
         console.log({ error })
         errorToast(_.get(error, 'message', t('something_wrong')))

      } finally {
         setloading(false)
      }

   }

   let updateStaffInfo = async (data) => {
      
      data.uid = selectedStaff.uid
      data.staffDocId = selectedStaff.id
      
      setloading(true)

      try {

         let url = `https://us-central1-tickting-system.cloudfunctions.net/updateStaff`
         let options = {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            redirect: 'follow'
         }

         let response = await fetch(`${url}`, options)

         if (!response.ok)
            throw await Promise.reject(await response.json())


         updateFormList()
         successToast(t('staff_was_updated'))
         toggle()

      } catch (error) {
         console.log({ error })
         errorToast(t('something_wrong'))

      } finally {
         setloading(false)
      }

   }


   return (
      <Modal
         isOpen={isOpen}
         toggle={toggle}
         title={`${t(isEdit ? 'edit_staff' : 'add_new_staff')}`}
         hasFooter={true}
         isSaving={loading}
         onSave={validation}
      >

         <div style={{ minHeight: '50vh', display: 'grid' }}>

            <LoadingOverlay
               spinner
               active={staffIsLoading}
               text={t('loading')}
               styles={{
                  overlay: (base) => ({
                     ...base,
                     background: '#fff',
                     color: '#000'
                  }),
                  spinner: (base) => ({
                     ...base,
                     // width: 'px',
                     '& svg circle': {
                        stroke: '#000'
                     }
                  })
               }}
            >

               {!_.isEmpty(form) && (
                  <Form
                     inputs={form}
                     onChange={setChanges}
                  />
               )}

            </LoadingOverlay>
         </div>

      </Modal>


   )
}

export default StaffModal

let staffOpts = (staff) => _.map(_.values(staff), member => ({
   label: member.name_en,
   value: member.id
}))

/**
 *
 *
 * @param {object} selectedStaff
 * @returns {object}
 */
function getEditForm(selectedStaff, staffOptsList) {

   let editForm = _.cloneDeep(formFields)

   // remove the selected staff from staffs droplist
   let opts = _.filter(staffOptsList, opt => opt.value !== selectedStaff?.id)
   editForm.manager.options = opts
   editForm.supervisor.options = opts

   // set the email & pass as not required fields
   _.set(editForm, 'email.required', false)
   _.set(editForm, 'password.required', false)
   _.set(editForm, 'confirmPassword.required', false)
   
   // re-name the pass field
   _.set(editForm, 'password.name', i18n.t('new_password'))
   _.set(editForm, 'confirmPassword.name', i18n.t('confirm_password'))

   // -------------------
   // set new permissons (NOTE: this is bcz these fields was add at the end 'after staffs are created' 🙄)
   // set a CanRedirectRequest if not exist 
   if (!_.has(selectedStaff, 'permissons.CanRedirectRequest')){ // to see the redirect input at the new request modal
      _.set(selectedStaff, 'permissons.CanRedirectRequest', false)
   }

   // set a CanSeeAllTickets if not exist 
   if (!_.has(selectedStaff, 'permissons.CanSeeAllTickets')){
      _.set(selectedStaff, 'permissons.CanSeeAllTickets', false)
   }

   // set a CanSeeAllTickets if not exist 
   if (!_.has(selectedStaff, 'permissons.CanCompleteRequest')){
      _.set(selectedStaff, 'permissons.CanCompleteRequest', false)
   }
   // -------------------

   // re-write the staff permissons obj as a checkbox fields
   let permissonsField = []
   _.forEach(_.get(selectedStaff, 'permissons'), (checked, key) => {
      permissonsField.push({
         id: key,
         value: _.startCase(key),
         checked,
      })
   })

   // set the permissons options
   let staffData = _.cloneDeep(selectedStaff)
   _.set(staffData, 'permissons', permissonsField)

   // update the fields values by the staff data
   let editInfoForm = updateForm(editForm, staffData)

   return editInfoForm
}
